import React from 'react';
import {bool, func, string, exact, oneOfType, object} from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import wrap from 'wraptile';

import {
    ColumnType,
    Sort,
    SortingOptionsValues,
    JSXStr,
} from '../tableTypes';
import TableHeaderCellSortable from './TableHeaderCellSortable';

type handleSortFn = (sort: Sort) => void;

interface TableHeader extends ColumnType {
    onClick?: handleSortFn,
    sort?: Sort,
}

interface handleClickArgs extends Sort {
    onClick: handleSortFn,
}

export const handleClick = wrap(({onClick, sortOrder, sortBy}: handleClickArgs): void => {
    onClick({
        sortBy,
        sortOrder,
    });
});

export const getSortDirection = (sort: Sort, dataKey: JSXStr) => sort.sortBy === dataKey ? sort.sortOrder : SortingOptionsValues.asc;
export const getIsSortActive = (sort: Sort, dataKey: JSXStr) => sort.sortBy === dataKey;
export const getType = (sort: Sort, dataKey: JSXStr) => dataKey !== sort.sortBy ? undefined : sort.sortOrder;

export default function TableHeaderCell(props: TableHeader) {
    const {
        title,
        dataKey,
        sortable,
        sort,
        onClick,
    } = props;
    
    if (sortable && onClick && dataKey && sort) {
        const onSort = handleClick({
            onClick,
            sortBy: dataKey,
            sortOrder: getType(sort, dataKey),
        });
        const sortDirection = getSortDirection(sort, dataKey);
        const isSortActive = getIsSortActive(sort, dataKey);
        
        return (
            <TableHeaderCellSortable
                title={title}
                onSort={onSort}
                sortDirection={sortDirection}
                isSortActive={isSortActive}
            />
        );
    }
    
    return (
        <TableCell
            className={dataKey as string}
            key={title as string}
            align="left"
        >
            {title}
        </TableCell>
    );
}

TableHeaderCell.propTypes = {
    title: oneOfType([
        string,
        object,
    ]),
    sortable: bool,
    onClick: func,
    sort: exact({
        sortBy: string,
        sortOrder: string,
    }),
};

TableHeaderCell.defaultProps = {
    title: '',
    sortable: false,
    sort: undefined,
    onClick: undefined,
};
